<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <sequential-entrance from-top>
      <v-row>
        <v-col>
          <base-material-card
            color="primary"
            icon="mdi-bank-transfer-out"
            inline
            title="Cash Connect Reports"
          >
            <v-col cols="12">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              />
            </v-col>
            <v-spacer />
            <v-data-table
              :headers="headers"
              :items="getccSites"
              :search="search"
              sort-by="calories"
              class="elevation-1"
            >
              <template v-slot:[`item.live`]="{ item }">
                <v-btn
                  small
                  fab
                  class="mr-2"
                  color="red"
                  @click="request_cashconnect_live(item)"
                >
                  <v-icon dark>
                    mdi-video-plus
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.transfers`]="{ item }">
                <v-btn
                  small
                  fab
                  class="mr-2"
                  color="lime"
                  @click="request_cashconnect_transfer(item)"
                >
                  <v-icon dark>
                    mdi-download
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.cit`]="{ item }">
                <v-btn
                  small
                  fab
                  class="mr-2"
                  color="cyan"
                  @click="request_cashconnect_cit(item)"
                >
                  <v-icon dark>
                    mdi-truck
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.files`]="{ item }">
                <v-btn
                  small
                  fab
                  class="mr-2"
                  color="purple"
                  @click="request_cashconnect_files(item)"
                >
                  <v-icon dark>
                    mdi-file-delimited
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:no-data>
                <v-btn
                  color="primary"
                  @click="initialize"
                >
                  Reset
                </v-btn>
              </template>
            </v-data-table>
          </base-material-card>

          <div class="py-3" />
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'Wallets',

    data () {
      return {
        bal: '',
        search: '',
        valid: true,
        headers: [
          { text: 'Site Name', value: 'idnum', sortable: true, align: 'center', width: 200 },
          { text: 'Group', value: 'group', sortable: true, align: 'center', width: 200 },
          { text: 'CC ID Number', value: 'ccid', sortable: true, align: 'center' },
          { text: 'Live', value: 'live', align: 'center', sortable: false },
          { text: 'Drops', value: 'transfers', align: 'center', sortable: false },
          { text: 'Pickups', value: 'cit', align: 'center', sortable: false },
          { text: 'Files', value: 'files', align: 'center', sortable: false },
        ],
        items: [],
        error: '',
        dialog: false,
        icons: true,
        centered: true,
        newtab: null,
        activeBtn: 1,
        grow: true,
        tab: null,

        tabs: 0,
      }
    },
    timers: {
      log: { time: 300000, autostart: true, repeat: true }
    },
    computed: {
      getccSites () {
        this.ccsites = []
        this.ccsites = this.$store.getters.getCashConnectSites
        console.log('loaded cc sites from view ', this.ccsites)
        let loadedsites = this.$store.getters.loadedSites
        this.ccsites.forEach(ccsite => {
          loadedsites.forEach(loadedsite => {
            if (ccsite.sitekey === loadedsite.sitekey) {
              Object.assign(ccsite, { group: loadedsite.group })
              if (ccsite.override) {
                ccsite.ccid = ccsite.override
              }
            }
          })
        })

        return this.ccsites
      },
      getlocs () {
        // make sure the site is cash connect enabled
        this.locations = []
        let today = moment().format('YYYY-MM-DD')
        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          let name = 'Unknown'
          let group = 'Unknown'
          let capacity = 3000
          let ccsites = this.$store.getters.getCashConnectSites.map(entry => entry.idnum)

          console.log('key is ', key)
          console.log('value is ', value)
          // ccsites.forEach(site => {
          //   console.log('cc list ', site)
          // })
          let loc = this.$store.getters.loadedSites.find(function (site) {
            if (site.idnum === key) {
              return true
            }
          })
          if (loc) {
            if (!loc.sitename) {
              console.log('loc no sitename ', loc)
            }
            if (loc.sitename === 'Rainbow 1369 (DOTS)') {
              console.log('rainbow 1369 ', loc.sitename, loc)
            }
            group = loc.group
            name = loc.sitename
            console.log('loc ', loc)
          }
          if (value.siteunitsprofile) {
            let safeid = Object.values(value.siteunitsprofile)[0].crypto_idnum
            let rec = this.$store.getters.getheartbeatvalues.find(element => element.crypto_idnum === safeid)
            let status = 'N/A'
            let ccid = ''
            this.$store.getters.getCashConnectSites.forEach(entry => {
              if (key === entry.idnum) {
                if (entry.override) {
                  ccid = entry.override
                } else {
                  ccid = entry.ccid
                }
              }
            })
            let shop = {
              idnum: key,
              group: group,
              safeid: safeid,
              capacity: capacity,
              ccid: ccid,
              status: status,
              sitename: name
            }
            if (safeid === 'S&S-01238A86BD2A5D7AEE') {
              console.log('1369 ', key, shop)
            }
            if (key.includes('1369')) {
              console.log('1369 ', key, shop)
            }

            let stat = this.$store.getters.user.status
            let usrmail = this.$store.getters.user.email
            if (stat === 'admin' || stat === 'CashConnect') {
              if (ccsites.includes(shop.idnum)) {
                console.log('IS CC SITE')
                this.locations.push(shop)
              }
            } else if (stat === 'storemanager' || stat === 'groupmanager' || stat === 'deposituser' || stat === 'vieweronly' || stat === 'deposituser') {
              if (allowedusers) {
                if (allowedusers.includes(usrmail)) {
                  if (ccsites.includes(shop.idnum)) {
                    console.log('IS CC SITE')
                    this.locations.push(shop)
                  }
                }
              }
            }
          }
          // this.$log.debug(key,value.siteunitsprofile)
        }
        this.$log.debug('our location map ', this.locations)
        console.log('our location map ', this.locations)
        return this.locations
      },
      currentsafes () {
        this.$log.debug('SAFES ARE ', this.$store.getters.safesstatus)
        return this.$store.getters.safesstatus
      },
      totalSales () {
        return this.sales.reduce((acc, val) => acc + val.salesInM, 0)
      },
      groupforuser () {
        let groups = []
        if (this.$store.getters.user.status === 'admin') {
          return this.$store.getters.usergroups
        }
        this.$store.getters.usergroups.forEach(entry => {
          if (entry.name === this.$store.getters.user.group) {
            groups.push(entry)
          }
        })
        return groups
      }
    },
    created () {
      this.$store.dispatch('loadccSites')

      // this.$store.getters.getCashConnectSites
      // this.$store.dispatch('resetsafetransactions')
      // this.items = this.$store.getters.safesstatus
    },
    methods: {
      log () {
        // this.$store.dispatch('loadsafes')
      },
      format_time (ts) {
        this.$log.debug('TS ', ts)
        return moment(ts).format('MMMM Do, h:mm:ss')
      },
      request_cashconnect_live (machine) {
        console.log(machine)
        this.$router.push({ path: '/CCLive/' + machine.idnum })
      },
      request_cashconnect_transfer (machine) {
        console.log(machine)
        this.$router.push({ path: '/CCTransfers/' + machine.idnum })
      },
      request_cashconnect_cit (machine) {
        console.log('CIT !!', machine)
        this.$router.push({ path: '/CCCit/' + machine.idnum })
      },
      request_cashconnect_files (machine) {
        console.log(machine)
        this.$router.push({ path: '/CCDailyFiles/' + machine.safeid })
      },
      reset () {
        this.wallet = ''
        this.dialog = false
      },
      onDecode (result) {
        // strip out crypto:address
        this.wallet.address = result
      },
      logErrors (promise) {
        promise.catch(console.error)
      },
      complete (index) {
        this.list[index] = !this.list[index]
      }
    }
  }
</script>
